<template>
    <v-container fluid grid-list-xl>
        <v-layout row wrap>
            <v-flex xs12 sm6 offset-sm3 mt-3>
                <v-layout row wrap align-center>
                    <v-flex xs12 sm4 d-flex>
                        <widget :sub-title="this.$t('subscriptions_widget_subtitle')" :title="subscription_size" icon="rss_feed" color="#03A9F4"></widget>
                    </v-flex>
                    <v-flex xs12 sm4 d-flex>
                        <widget :sub-title="this.$t('subscribers_widget_subtitle')" :title="subscribers_size" icon="people" color="#8BC34A"></widget>
                    </v-flex>
                    <v-flex xs12 sm4 d-flex>
                        <widget :sub-title="this.$t('publications_widget_subtitle')" :title="publications_size" icon="notifications" color="#FFC107"></widget>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 sm6 offset-sm3 mt-3>
                <api-result-viewer :data="api_response"></api-result-viewer>

                <v-alert :value="items.length === 0 && api_response === 0" color="success" outline>
                    {{this.$t('not_subscriptions_message')}}
                </v-alert>

                <v-list two-line v-if="api_response === 0 && items.length > 0">
                    <template v-for="(item, index) in items">
                        <v-list-tile :key="item.name" avatar :to="'/device/' + item.deviceName">
                            <v-list-tile-avatar>
                                <v-icon>devices</v-icon>
                            </v-list-tile-avatar>

                            <v-list-tile-content>
                                <v-list-tile-title>{{item.name}}</v-list-tile-title>
                                <v-list-tile-sub-title>@{{item.deviceName}}</v-list-tile-sub-title>
                            </v-list-tile-content>
                        </v-list-tile>

                        <v-divider :key="index"></v-divider>
                    </template>
                </v-list>
            </v-flex>
        </v-layout>
    </v-container>
</template>

<script>
    import DeviceService from '../apiServices/DeviceService'
    import ApiResultViewer from "../components/api/APIResultViewer";
    import Widget from "../components/Widget";

    export default {
        name: "Dashboard",
        data() {
            return {
                items: [],
                api_response: true,
                subscription_size: '-',
                subscribers_size: '-',
                publications_size: '-'
            }
        },
        mounted() {
            this.loadData()
        },
        methods:{
            loadData(){
                const dService = new DeviceService(this.$store.getters.getDevice.deviceName);
                //Load subscriptions
                this.api_response = 1;
                dService.getSubscriptions()
                    .then(response => {
                        this.items = response.data;
                        this.subscription_size = String(this.items.length);
                        this.api_response = 0;
                    })
                    .catch((error) => {
                        this.api_response = error;
                    })

                //Load number of publications
                dService.getPublications()
                    .then(response => {
                        this.publications_size = String(response.data.length)
                    })
                    .catch((error) => {
                        window.console.log(error.toString())
                    })

                //Load number of subscribers
                dService.getSubscribers()
                    .then(response => {
                        this.subscribers_size = String(response.data.length)
                    })
                    .catch((error) => {
                        window.console.log(error.toString())
                    })
            }
        },
        components: {
            ApiResultViewer,
            Widget
        }
    }
</script>

<style scoped>
</style>

<i18n>
    {
        "en": {
            "subscriptions_widget_subtitle": "Subscriptions",
            "subscribers_widget_subtitle": "Subscribers",
            "publications_widget_subtitle": "Publications",
            "not_subscriptions_message": "You do not have subscriptions"
        },
        "es": {
            "subscriptions_widget_subtitle": "Suscripciones",
            "subscribers_widget_subtitle": "Subscriptores",
            "publications_widget_subtitle": "Publicaciones",
            "not_subscriptions_message": "No tiene suscripciones"
        }
    }
</i18n>